import { Platform } from 'react-native';

let fontsInjected = false;

/** Precarga Plus Jakarta Sans + IBM Plex Mono en web. Idempotente. */
export function ensureTicketFonts(): void {
  if (fontsInjected || Platform.OS !== 'web' || typeof document === 'undefined') {
    return;
  }
  fontsInjected = true;

  if (document.getElementById('vuelto-ticket-fonts')) {
    return;
  }

  const fontStylesheetUrl =
    'https://fonts.googleapis.com/css2?family=IBM+Plex+Mono:wght@500;600;700&family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap';
  const preconnect = document.createElement('link');
  preconnect.rel = 'preconnect';
  preconnect.href = 'https://fonts.gstatic.com';
  preconnect.crossOrigin = 'anonymous';
  document.head.appendChild(preconnect);

  const preload = document.createElement('link');
  preload.rel = 'preload';
  preload.as = 'style';
  preload.href = fontStylesheetUrl;
  document.head.appendChild(preload);

  const link = document.createElement('link');
  link.id = 'vuelto-ticket-fonts';
  link.rel = 'stylesheet';
  link.href = fontStylesheetUrl;
  document.head.appendChild(link);
}

/** @deprecated Usar ensureTicketFonts */
export const ensurePosTicketFonts = ensureTicketFonts;
